import { lazy, Suspense } from 'react'

const SleepDetailPage = lazy(async () => {
  const module = await import('@/features/sleep/SleepDetailPage')
  return { default: module.SleepDetailPage }
})

const SleepFormPage = lazy(async () => {
  const module = await import('@/features/sleep/SleepForm')
  return { default: module.SleepFormPage }
})

function SleepRouteFallback() {
  return <p role="status">正在加载页面…</p>
}

export function SleepDetailRoute() {
  return (
    <Suspense fallback={<SleepRouteFallback />}>
      <SleepDetailPage />
    </Suspense>
  )
}

export function SleepFormRoute() {
  return (
    <Suspense fallback={<SleepRouteFallback />}>
      <SleepFormPage />
    </Suspense>
  )
}
